export const GET_CART = 'GET_CART'
export const ADD_TO_CART = 'ADD_TO_CART'
export const DELETE_FROM_CART = 'DELETE_FROM_CART'
export const CART_LOADING = 'CART_LOADING'
export const GET_ITEMS_CART = 'GET_ITEMS_CART'
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART'
export const DELETE_ITEM_FROM_CART = 'DELETE_ITEM_FROM_CART'
export const CART_ITEM_LOADING = 'CART_ITEM_LOADING' 
export const UPDATE_CART_ITEM_COUNT = 'UPDATE_CART_ITEM_COUNT'
export const UPDATE_CART_ITEM_QUANTITY = "UPDATE_CART_ITEM_QUANTITY"